import { Component, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { TokenStorageService } from 'src/app/shared/token-storage';
import { CommonService } from '../../common.service';
import { TextConstantsService } from '../../text-constants';

@Component({
  selector: 'dashboard-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
})
export class NavigationComponent implements OnInit {
  // @Input() public showNavigationMain: boolean;
  @Input() public showFilter: boolean;
  @Output() public user: any;

  accordion: any = [
    {
      name: 'Status',
      id: 1,
      items: [
        {
          title: 'Neu',
        },
        {
          title: 'Freigegeben',
        },
        {
          title: 'Im Gange',
        },
        {
          title: 'Abgeschlossen',
        },
        {
          title: 'Storniert',
        },
      ]
    },
    {
      name: 'Büroadressen',
      id: 2,
      items: [
        {
          title: 'Hanns-Eisler-Str. 90, 10409 Berlin, 01799503412',
        },
        {
          title: 'Cuvrystraße 44, 10997 Berlin, 01742632104',
        },
        {
          title: 'Stuckstraße 16, 12435 Berlin, 017672586099',
        },
        {
          title: 'Regattastraße 25, 12527 Berlin, 017631342336',
        },
      ]
    },
    {
      name: 'Items',
      id: 3,
      items: [
        {
          title: 'Box 1',
        },
        {
          title: 'Box 2',
        },
        {
          title: 'Box 3',
        },
        {
          title: 'Box 4',
        },
        {
          title: 'Box 5',
        },
        {
          title: 'Box 6',
        },
        {
          title: 'Box 7',
        },
        {
          title: 'Box 8',
        },
        {
          title: 'Box 9',
        },
        {
          title: 'Box 10',
        },
        {
          title: 'Box 11',
        },
        {
          title: 'Box 12',
        },
        {
          title: 'Box 13',
        }
      ]
    }
  ];

  searchFilterItems: string = '';

  navigation: any = {
    Header: [{
      type: 'avatar',
      href: '/admin/users',
      icon: '',
      label: '',
    }],
    Dashboard: [{
      href: '/admin/dashboard',
      icon: 'uil-apps',
      label: 'Dashboard',
    }],
    Onlineshop: [{
      href: '/admin/orders-services',
      icon: 'uil-shopping-bag',
      label: 'Geb. Leistungen',
    }, {
      href: '/admin/orders',
      icon: 'uil-shopping-cart',
      label: 'Aufträge',
    }, {
      href: '/admin/coupons',
      icon: 'uil-tag-alt',
      label: 'Aktionen & Gutscheine',
    }, {
      href: '',
      icon: 'uil-file-alt',
      label: 'Dokumentation',
    }, {
      href: '',
      icon: 'uil-wrench',
      label: 'Einstellungen',
    }
    ],
    Administration: [{
      href: '/admin/chat',
      icon: 'uil-comment-alt-message',
      label: 'Chat',
      hideMenu: true,
    }, {
      href: '/admin/users',
      icon: 'uil-user',
      label: 'Benutzer',
    }, {
      href: '/admin/time-log',
      icon: 'uil-clock-eight',
      label: 'Zeitprotokoll',
    }, {
      href: '/admin/request-logs',
      icon: 'uil-file-import',
      label: 'Request Logs',
    }],
    System: [{
      type: 'logout',
      href: '#',
      icon: 'uil-sign-out-alt',
      label: 'Ausloggen',
    }
    ],
    /*
    Administration: [{
      href: '/admin/chat',
      icon: 'uil-comment-alt-message',
      label: 'Chat',
      hideMenu: true,
    }, {
      href: '/admin/users',
      icon: 'uil-user',
      label: 'Benutzer',
    }, {
      href: '/admin/time-log',
      icon: 'uil-clock-eight',
      label: 'Zeitprotokoll',
    }, {
      href: '/admin/access-rights',
      icon: 'uil-lock-access',
      label: 'Access Rights',
    }, {
      href: '/admin/logs',
      icon: 'uil-clipboard-notes',
      label: 'Logs',
    }, {
      href: '/admin/monitoring',
      icon: 'uil-wifi-router',
      label: 'Terminals',
    }, {
      href: '/admin/locks',
      icon: 'uil-unlock-alt',
      label: 'Locks',
    }, {
      href: '/admin/domains',
      icon: 'uil-globe',
      label: this.tc.domains[this.tc.l],
    }, {
      href: '/admin/locations',
      icon: 'uil-sign-alt',
      label: this.tc.locations[this.tc.l],
    }
    ],
    System: [{
      href: '/admin/settings',
      icon: 'uil-setting',
      label: 'Einstellungen',
    }, {
      type: 'logout',
      href: '#',
      icon: 'uil-sign-out-alt',
      label: 'Ausloggen',
    }
    ],
    */
  };

  constructor(
    public commonService: CommonService,
    public tokenStorage: TokenStorageService,
    public router: Router,
    public tc: TextConstantsService,
  ) {
    this.user = commonService.getUser();
    console.log(25, this.user);

    if (this.user.company === 'zeitlagercity') {
      this.navigation = {
        Header: [{
          type: 'avatar',
          href: '/admin/users',
          icon: '',
          label: '',
        }],
        Dashboard: [{
          href: '/admin/dashboard',
          icon: 'uil-apps',
          label: 'Dashboard',
        }],
        Bagbuddy24: [{
          href: '/admin/access-rights',
          icon: 'uil-lock-access',
          label: 'Access Rights',
        }, {
          href: '/admin/locks',
          icon: 'uil-unlock-alt',
          label: 'Locks / Boxes',
        }, {
          href: '/admin/monitoring',
          icon: 'uil-wifi-router',
          label: 'Terminals',
        }, {
          href: '/admin/logs',
          icon: 'uil-clipboard-notes',
          label: 'Logs',
        },
        ],
        Franchising: [{
          href: '/admin/franchisees',
          icon: 'uil-sitemap',
          label: this.tc.franchisees[this.tc.l],
        }, {
          href: '/admin/locations',
          icon: 'uil-sign-alt',
          label: this.tc.locations[this.tc.l],
        }, {
          href: '/admin/locations-groups',
          icon: 'uil-layer-group',
          label: 'Map Configuration',
        },/* {
          href: '/admin/monitoring',
          icon: 'uil-wifi-router',
          label: 'Terminals',
        },{
          href: '/admin/domains',
          icon: 'uil-globe',
          label: this.tc.domains[this.tc.l],
        } */ 
        ],
        Vouchers: [{
          href: '/admin/coupons',
          icon: 'uil-shopping-cart',
          label: 'Vouchers',
        }],
        OrderServices: [{
          href: '/admin/orders',
          icon: 'uil-shopping-cart',
          label: 'Orders',
        }],
        Monitoring: [{
          href: '/admin/payment-monitoring',
          icon: 'uil-credit-card',
          label: 'Payment Monitoring',
        }],
        Administration: [{
          href: '/statistics',
          icon: 'uil-chart-line',
          label: 'Statistics'
        },
        {
          href: '/admin/translate',
          icon: 'uil-language',
          label: 'Translations',
        }, /*{
          href: '/admin/time-log',
          icon: 'uil-clock-eight',
          label: 'Zeitprotokoll',
        }, */{
          href: '/admin/real-time-monitoring',
          icon: 'uil-server',
          label: 'Real Time Monitoring',
        }, 
        {
          href: '/admin/price-import',
          icon: 'uil-language',
          label: 'ListPrice Import',
        },
        {
          href: '/admin/timezones',
          icon: 'uil-clock',
          label: this.tc.timezones[this.tc.l],
        },
        // {
        //   href: '/admin/request-logs',
        //   icon: 'uil-server',
        //   label: 'Server Logs',
        // }
          // , {
          //   href: '/admin/chat',
          //   icon: 'uil-comment-alt-message',
          //   label: 'Chat',
          //   hideMenu: true,
          // }
        ],
        System: [{
          type: 'logout',
          href: '#',
          icon: 'uil-sign-out-alt',
          label: 'Logout',
        }
        ],
      };
    }
    if (this.user.companyObject?.franchisorCompany === 'zeitlagercity') {
      this.navigation = {
        Header: [{
          type: 'avatar',
          href: '/admin/users',
          icon: '',
          label: '',
        }],
        Dashboard: [{
          href: '/admin/dashboard',
          icon: 'uil-apps',
          label: 'Dashboard',
        }],
        Bagbuddy24: [
        {
          href: '/admin/access-rights',
          icon: 'uil-lock-access',
          label: 'Access Rights',
        },
        {
          href: '/admin/locks',
          icon: 'uil-unlock-alt',
          label: 'Locks / Boxes',
        }, {
          href: '/admin/monitoring',
          icon: 'uil-wifi-router',
          label: 'Terminals',
        }, {
          href: '/admin/logs',
          icon: 'uil-clipboard-notes',
          label: 'Logs',
        },
         {
          href: '/statistics',
          icon: 'uil-chart-line',
          label: 'Statistics'
        }
        ],
        Monitoring: [{
          href: '/admin/payment-monitoring',
          icon: 'uil-credit-card',
          label: 'Payment Monitoring',
        }],
        Franchising: [{
          href: '/admin/locations',
          icon: 'uil-sign-alt',
          label: this.tc.locations[this.tc.l],
        }],
         Vouchers: [{
          href: '/admin/coupons',
          icon: 'uil-shopping-cart',
          label: 'Vouchers',
        }],
	        OrderServices: [{
	          href: '/admin/orders',
	          icon: 'uil-shopping-cart',
	          label: 'Orders',
	        }],
            Administration: [{
	          href: '/admin/timezones',
	          icon: 'uil-clock',
	          label: this.tc.timezones[this.tc.l],
	        }],
	        System: [{
          type: 'logout',
          href: '#',
          icon: 'uil-sign-out-alt',
          label: 'Ausloggen',
        }],
      };
    }

    if (this.user.company === 'campermarkenwelt') {
      this.navigation = {
        Header: [{
          type: 'avatar',
          href: '/admin/users',
          icon: '',
          label: '',
        }],
        Dashboard: [{
          href: '/admin/dashboard',
          icon: 'uil-apps',
          label: 'Dashboard',
        }],
        Administration: [
          //   {
          //   href: '/admin/translate',
          //   icon: 'uil-language',
          //   label: 'Übersetzungen',
          // },
          {
            href: '/admin/chat',
            icon: 'uil-comment-alt-message',
            label: 'Chat',
            hideMenu: true,
          }
        ],
        System: [{
          type: 'logout',
          href: '#',
          icon: 'uil-sign-out-alt',
          label: 'Ausloggen',
        }
        ],
      };
    }
  }

  ngOnInit() { }


  showAccordion(accordion) {
    if (this.accordion.includes(accordion)) {
      const index = this.accordion.indexOf(accordion);
      if (index > -1) {
        this.accordion.splice(index, 1);
      }
    } else {
      this.accordion.push(accordion)
    }

  }

  logout() {
    this.tokenStorage.signOut();
    this.router.navigateByUrl('/login')
  }

  active(e) {
    if (e.href === window.location.href) {
      return true;
    } else {
      return false;
    }
  }
  keys(object) {
    return Object.keys(object);
  }
}
